export const TOOLTIPS = {
  approve: { text: "Aprobar", name: "approve-tooltip" },
  comment: { text: "Comentar", name: "comment-tooltip" },
  delete: { text: "Eliminar", name: "delete-tooltip" },
  download: { text: "Descargar", name: "download-tooltip" },
  edit: { text: "Editar", name: "edit-tooltip" },
  reject: { text: "Rechazar", name: "reject-tooltip" },
};
